import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { GatheringSpotType } from '@outdoria/types';
import { fetcher } from '../utils';
import {
  ADMIN_GATHERING_SPOT_TYPES_CREATE,
  GATHERING_SPOT_TYPES_ALL,
} from '../queryKeys';

export const useAdminCreateGatheringSpotType = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (
    gatheringSpotType: Omit<GatheringSpotType, 'gathering_spot_type_id'>,
  ): Promise<void> => {
    const response = await fetcher(`/v2/admin/gathering_spot_types`, {
      method: 'POST',
      body: JSON.stringify(gatheringSpotType),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 201)
      throw new Error((await response.json()).error ?? 'Did not work!');
    queryClient.invalidateQueries({ queryKey: GATHERING_SPOT_TYPES_ALL });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_GATHERING_SPOT_TYPES_CREATE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
